import React from 'react';
import { CardContent, Card as CardCore, CardDescription, CardFooter, CardHeader, CardTitle } from "./card";
export function Card(_ref) {
  var children = _ref.children,
    title = _ref.title,
    description = _ref.description,
    footer = _ref.footer,
    className = _ref.className,
    headerClassName = _ref.headerClassName,
    contentClassName = _ref.contentClassName;
  return /*#__PURE__*/React.createElement(CardCore, {
    className: className
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: headerClassName
  }, /*#__PURE__*/React.createElement(CardTitle, null, title), description ? /*#__PURE__*/React.createElement(CardDescription, null, description) : null), /*#__PURE__*/React.createElement(CardContent, {
    className: contentClassName
  }, children), footer ? /*#__PURE__*/React.createElement(CardFooter, null, footer) : null);
}